/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  position: relative;
  width: inherit;
  height: auto;
  .fill-1 {
    fill: #fff;
  }
  .fill-2 {
    fill: #000;
  }
`
export default class VolleyballIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" viewBox="0 0 90 90" css={Color}>
        <g id="그룹_7157" data-name="그룹 7157" transform="translate(-638.4 -338.6)">
          <circle id="타원_634" className="fill-1" data-name="타원 634" cx="45" cy="45" r="45" transform="translate(638.4 338.6)" fill="#fff"/>
          <path id="패스_6704" className="fill-2" data-name="패스 6704" d="M683.4,428.6a45,45,0,1,1,45-45A45.051,45.051,0,0,1,683.4,428.6Zm0-85a40,40,0,1,0,40,40A40.045,40.045,0,0,0,683.4,343.6Z"/>
          <path id="빼기_1" className="fill-2" data-name="빼기 1" d="M683.8,426.669h-.74a77.861,77.861,0,0,0,24.025-48.563l.16-1.544-1.5.118a52.635,52.635,0,0,0-20.325,5.835l-.645.34-.04.741a57.815,57.815,0,0,1-18.375,39.266c-1.03-.484-2-.993-2.945-1.544a54.559,54.559,0,0,0,8.655-9.73l.705-1.029-.96-.756a84.085,84.085,0,0,1-28.415-42.95,47,47,0,0,1,1.97-4.657,80.864,80.864,0,0,0,27.9,44.833l1.15.926.71-1.317a56.462,56.462,0,0,0,6.575-23.423l.065-.746-.61-.411a56.94,56.94,0,0,1-23.65-34.964c.86-.7,1.76-1.364,2.675-1.991a57.437,57.437,0,0,0,4.16,12.632l.525,1.127,1.1-.514a65.693,65.693,0,0,1,54.3-.01,41.315,41.315,0,0,1,2.5,4.631,63.916,63.916,0,0,0-29.56-7.26,62.912,62.912,0,0,0-25.515,5.346l-1.355.6.79,1.276a54.162,54.162,0,0,0,15.87,16.569l.6.406.64-.324a54.566,54.566,0,0,1,25.025-6.1,53.879,53.879,0,0,1,17.355,2.856c.155,1.158.265,2.315.335,3.447a51.591,51.591,0,0,0-15.46-3.19l-1.185-.067-.12,1.22a81.182,81.182,0,0,1-22.61,48.759C686.4,426.612,685.12,426.669,683.8,426.669Z"/>
        </g>
      </svg>
    )
  }
}
